var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-upload-container" }, [
    _c(
      "div",
      {
        staticClass: "file-drop-zone",
        class: {
          "drag-over": _vm.isDragOver,
          "has-file": _vm.selectedFile,
          "has-error": _vm.hasError,
        },
        on: {
          dragover: function ($event) {
            $event.preventDefault()
            return _vm.onDragOver.apply(null, arguments)
          },
          dragleave: function ($event) {
            $event.preventDefault()
            return _vm.onDragLeave.apply(null, arguments)
          },
          drop: function ($event) {
            $event.preventDefault()
            return _vm.onDrop.apply(null, arguments)
          },
          click: _vm.triggerFileInput,
        },
      },
      [
        _c("input", {
          ref: "fileInput",
          staticStyle: { display: "none" },
          attrs: { type: "file", accept: _vm.accept },
          on: { change: _vm.onFileSelect },
        }),
        _c("div", { staticClass: "upload-content" }, [
          !_vm.selectedFile
            ? _c("div", { staticClass: "upload-placeholder" }, [
                _vm._m(0),
                _c("p", { staticClass: "upload-text" }, [
                  _vm._v("Drag and drop a file here or click"),
                ]),
                _c("p", { staticClass: "upload-hint" }, [
                  _vm._v(_vm._s(_vm.acceptedFormatsText)),
                ]),
              ])
            : _c("div", { staticClass: "file-preview" }, [
                _c("div", { staticClass: "file-info" }, [
                  _c("i", {
                    staticClass: "fa fa-file-excel-o fa-2x text-success",
                  }),
                  _c("div", { staticClass: "file-details" }, [
                    _c("p", { staticClass: "file-name" }, [
                      _vm._v(_vm._s(_vm.selectedFile.name)),
                    ]),
                    _c("p", { staticClass: "file-size" }, [
                      _vm._v(_vm._s(_vm.formatFileSize(_vm.selectedFile.size))),
                    ]),
                  ]),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-danger remove-file",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.removeFile.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                ),
              ]),
          _vm.hasError
            ? _c("div", { staticClass: "error-message" }, [
                _c("i", { staticClass: "fa fa-exclamation-triangle" }),
                _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-icon" }, [
      _c("i", { staticClass: "fa fa-cloud-upload fa-3x" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }